import script from "./HomeMenuDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeMenuDown.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__